<ng-container *ngIf="flyingClubs.length >= 1; else placeholder">
  <app-flyingclub-summary *ngFor="let flyingClub of sortedClubs" [flyingClub]="flyingClub"></app-flyingclub-summary>
</ng-container>
<ng-template #placeholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">There are no flying clubs listed as operating at this airport.  <a target="_blank" href="https://www.aopa.org/community/flying-clubs/start-a-flying-club">View AOPA resources for starting a flying club.</a></div>
  </div>
</ng-template>
